// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const nidoking: PokeData = {
  "id": 34,
  "name": "nidoking",
  "height": 14,
  "weight": 620,
  "base_experience": 227,
  "types": [
    PokeType.POISON,
    PokeType.GROUND
  ],
  "api_moves": [
    "double-kick",
    "horn-attack",
    "fury-attack",
    "tackle",
    "thrash",
    "poison-sting",
    "leer",
    "supersonic",
    "peck",
    "counter",
    "toxic",
    "focus-energy",
    "megahorn",
    "flatter",
    "helping-hand",
    "toxic-spikes",
    "poison-jab",
    "earth-power",
    "sludge-wave",
    "chip-away"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "leer",
    "supersonic",
    "peck",
    "flatter",
    "toxic-spikes",
    "poison-jab",
    "earth-power",
    "rototiller",
    "mud-bomb",
    "fissure",
    "sludge-bomb"
  ],
  "evolution_chain": {
    "id": 13,
    "item": null,
    "species": [
      {
        "name": "nidoran-m",
        "order": 33,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "nidorino",
        "order": 34,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 32,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "nidoking",
        "order": 35,
        "types": [
          PokeType.POISON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 33,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 118,
    "speed": 128,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
